import { dataService } from '../../../services/data.services';

export const formatNoticeTypeLabel = (typeKey = '') => String(typeKey || '')
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const fetchNoticeTypeOptions = async (branchId, module = 'updates') => {
    const res = await dataService.GetAPI(`notice-board/notice-types?branch_id=${branchId}&module=${module}`);
    const noticeTypes = res.data?.data?.data?.data || res.data?.data?.data || [];
    return noticeTypes.map((item) => ({
        _id: item._id,
        value: item.type_key,
        label: item.type_label,
        typeKey: item.type_key,
        isDefault: item.is_default,
    }));
};

export const createNoticeTypeOption = async ({ branchId, typeLabel, module = 'updates' }) => {
    const response = await dataService.PostAPI({
        branch_id: branchId,
        module,
        type_label: typeLabel,
    }, 'notice-board/notice-types');
    const responsePayload = response?.data?.data || response?.data || {};
    const createdType = responsePayload?.data || responsePayload;

    return {
        message: responsePayload?.message,
        option: createdType?._id ? {
            _id: createdType._id,
            value: createdType.type_key,
            label: createdType.type_label,
            typeKey: createdType.type_key,
            isDefault: createdType.is_default,
        } : null,
    };
};

export const resolveNoticeTypeValue = (typeIdOrKeyOrLabel, noticeTypeOptions = []) => {
    if (!typeIdOrKeyOrLabel) return '';
    const matchedType = noticeTypeOptions.find((item) => (
        item.value === typeIdOrKeyOrLabel
        || item.typeKey === typeIdOrKeyOrLabel
        || item.label === typeIdOrKeyOrLabel
    ));
    return matchedType?.value || typeIdOrKeyOrLabel;
};

export const getNoticeTypeLabel = (typeIdOrKey, noticeTypeOptions = [], fallbackLabel = '') => {
    const matchedType = noticeTypeOptions.find((item) => (
        item.value === typeIdOrKey
        || item.typeKey === typeIdOrKey
        || item.label === typeIdOrKey
    ));
    return matchedType?.label || fallbackLabel || formatNoticeTypeLabel(typeIdOrKey);
};
